import PropTypes from 'prop-types';

function IFFruitInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M20.2374 9.73237H22.2741C22.8687 9.70519 23.4507 9.55144 23.9812 9.28139C24.5117 9.01135 24.9785 8.63122 25.3504 8.1664C26.8479 6.26242 26.4928 3.31445 26.4928 3.31445C22.2997 3.31445 20.8322 5.2655 20.353 7.01545C20.1229 7.90276 20.0835 8.82875 20.2374 9.73237Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.602 20.4924C28.9614 20.0218 29.3251 19.5854 29.7273 19.1532C29.758 19.1075 29.778 19.0555 29.7859 19.001C29.7938 18.9465 29.7894 18.8909 29.773 18.8384C29.7566 18.7858 29.7286 18.7376 29.691 18.6973C29.6535 18.657 29.6074 18.6257 29.5561 18.6056C28.8972 18.3873 28.2897 18.0237 28.2897 17.1594C28.2891 17.0152 28.3063 16.8715 28.341 16.7315C28.0925 16.5202 27.8922 16.2581 27.7534 15.9629C27.6147 15.6677 27.5408 15.3462 27.5366 15.0201C27.5401 14.693 27.6146 14.3705 27.755 14.075C27.8954 13.7795 28.0982 13.518 28.3496 13.3086C27.9777 12.9343 27.762 12.4326 27.7463 11.9052C27.7463 11.3619 28.1741 10.8655 28.5421 10.4676C28.5421 10.4676 27.2286 9.27818 25.3545 10.9511C23.4805 12.6241 24.4389 19.3458 26.2402 20.1031C28.0415 20.8604 28.602 20.4924 28.602 20.4924Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M26.3089 17.8311C26.3089 17.6856 26.403 17.5401 26.3645 17.4032C26.1634 16.7657 25.3847 16.5475 25.3847 15.8843C25.3936 15.3635 25.5878 14.863 25.9324 14.4724C25.9982 14.395 26.0365 14.298 26.0411 14.1965C26.0458 14.0951 26.0166 13.9949 25.958 13.9119C25.7195 13.5754 25.591 13.1734 25.5901 12.7609C25.5901 11.8581 27.1218 11.0752 28.2813 10.6858C28.3491 10.6633 28.4108 10.6256 28.4616 10.5756C28.5125 10.5255 28.5512 10.4645 28.5748 10.3971C28.5984 10.3297 28.6061 10.2578 28.5975 10.187C28.5889 10.1161 28.5642 10.0482 28.5252 9.98839C28.1864 9.5074 27.752 9.10147 27.2492 8.79595C26.7463 8.49044 26.1859 8.29191 25.6029 8.21277C25.5236 8.19949 25.4422 8.20756 25.367 8.23613C25.2918 8.2647 25.2255 8.31275 25.1751 8.37535C24.4292 9.18314 23.3977 9.66818 22.2998 9.7274H20.6354C20.5223 9.73194 20.4115 9.6948 20.3239 9.62303C20.2364 9.55126 20.1782 9.44985 20.1605 9.33804C20.1 8.7215 20.1245 8.09956 20.2333 7.48968C20.2449 7.4289 20.2443 7.3664 20.2313 7.30589C20.2184 7.24537 20.1934 7.18807 20.1579 7.13739C20.1224 7.08671 20.077 7.04368 20.0246 7.01085C19.9721 6.97803 19.9136 6.95607 19.8525 6.9463C19.4989 6.88753 19.1412 6.85748 18.7828 6.85645C15.1888 6.85645 13.0666 7.99456 10.3796 10.2793C9.22438 11.2591 9.00189 11.2634 8.27881 12.7609C7.94151 13.5561 7.73073 14.3993 7.65413 15.2596C7.65413 15.6875 7.65413 17.476 7.65413 17.9894C7.77268 19.3185 8.108 20.6193 8.64677 21.8402C9.34846 23.5516 9.50249 23.6586 10.7476 24.8352C13.0623 27.0472 15.454 28.3479 18.7785 28.3479C20.7167 28.3479 23.5449 27.9201 25.0167 26.5252C26.7282 24.9165 27.2801 22.1397 28.7391 20.2999C28.8119 20.2057 28.8932 20.1116 28.9702 20.0175C27.0063 20.1073 26.3089 18.751 26.3089 17.8311Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.012 11.2342C14.3329 10.6908 9.93874 12.7103 10.4051 17.0274C10.6362 18.7389 11.2352 19.1197 11.2352 19.1197C11.2352 19.1197 12.2492 14.2549 14.012 11.2342Z"
                fill="#F8F2ED"
                stroke="#453D3D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFFruitInactive;

IFFruitInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFFruitInactive.defaultProps = {
    className: null,
    width: 28,
};
